// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xubo","buttons":"styles_buttons__2eiNg"};